import { CLEAR_RESPONSES } from '../actions/responses'

const responses = (state = {}, action:any = {}) => {
  switch (action.type) {
    case CLEAR_RESPONSES:
      state = {}
      break
  }
  return state
}

export default responses
